import { toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  href: "#",
  class: "btn_sort"
}
const _hoisted_2 = { class: "layer_cont" }
const _hoisted_3 = { class: "option_lst" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: "filter_bx",
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSortOptionPopup && _ctx.toggleSortOptionPopup(...args)), ["prevent"]))
    }, [
      _createVNode("a", _hoisted_1, _toDisplayString(_ctx.getSortOptionName), 1)
    ]),
    _createVNode("div", {
      class: ["ly_filter", {is_op: _ctx.showSortOptionPopup}]
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("ul", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortOptionList, (sortOption, index) => {
            return (_openBlock(), _createBlock("li", {
              key: index,
              onClick: _withModifiers(($event: any) => (_ctx.changeSortOption(index)), ["prevent"])
            }, [
              _createVNode("a", {
                href: "#none",
                class: ["opt", {is_selected: sortOption.isSelected}]
              }, _toDisplayString(sortOption.name), 3)
            ], 8, ["onClick"]))
          }), 128))
        ])
      ])
    ], 2)
  ], 64))
}